module.exports = __webpack_public_path__ + "img/lisa_d_2.2f71d9b2.png";